// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as HyperLogger$OrcaPaymentPage from "./hyper-log-catcher/HyperLogger.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "./Hooks/UtilityHooks.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "./Utilities/PaymentHelpers.bs.js";

function Redsys3ds(props) {
  let logger = HyperLogger$OrcaPaymentPage.make(undefined, {
    TAG: "Elements",
    _0: "Payment"
  }, undefined, undefined, undefined);
  let isCompleteAuthorizeCalledRef = React.useRef(false);
  let timeoutRef = React.useRef(undefined);
  let eventsToSendToParent = [
    "confirmParams",
    "poll_status",
    "openurl_if_required"
  ];
  let completeAuthorize = PaymentHelpers$OrcaPaymentPage.useRedsysCompleteAuthorize(logger);
  let handleCompleteAuthorizeCall = (threeDsMethodComp, clientSecret, publishableKey, headers, returnUrl, sdkAuthorization) => {
    isCompleteAuthorizeCalledRef.current = true;
    let body = [[
        "threeds_method_comp_ind",
        threeDsMethodComp
      ]];
    if (sdkAuthorization === "") {
      body.push([
        "client_secret",
        clientSecret
      ]);
    }
    completeAuthorize(undefined, body, {
      return_url: returnUrl,
      publishableKey: publishableKey
    }, "redsys3ds", clientSecret, headers, sdkAuthorization);
  };
  UtilityHooks$OrcaPaymentPage.useSendEventsToParent(eventsToSendToParent);
  React.useEffect(() => {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "iframeMountedCallback",
        true
      ]]);
    let handle = ev => {
      try {
        let json = Utils$OrcaPaymentPage.safeParse(ev.data);
        let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
        if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
          return;
        }
        let metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
        let metaDataDict = Core__Option.getOr(Core__JSON.Decode.object(metadata), {});
        let clientSecret = Utils$OrcaPaymentPage.getString(metaDataDict, "clientSecret", "");
        let publishableKey = Utils$OrcaPaymentPage.getString(metaDataDict, "publishableKey", "");
        let sdkAuthorization = Utils$OrcaPaymentPage.getString(metaDataDict, "sdkAuthorization", "");
        logger.setClientSecret(clientSecret);
        logger.setSdkAuthorization(sdkAuthorization);
        logger.setMerchantId(publishableKey);
        let headersDict = Utils$OrcaPaymentPage.getDictFromDict(metaDataDict, "headers");
        let headers = Utils$OrcaPaymentPage.convertDictToArrayOfKeyStringTuples(headersDict);
        let confirmParam = Utils$OrcaPaymentPage.getDictFromObj(metaDataDict, "confirmParams");
        let returnUrl = Utils$OrcaPaymentPage.getString(confirmParam, "return_url", "");
        let iframeDataDict = Utils$OrcaPaymentPage.getDictFromObj(metaDataDict, "iframeData");
        let methodKey = Utils$OrcaPaymentPage.getString(iframeDataDict, "method_key", "threeDSMethodData");
        let threeDsMethodUrl = Utils$OrcaPaymentPage.getString(iframeDataDict, "three_ds_method_url", "");
        let threeDsMethodData = Utils$OrcaPaymentPage.getString(iframeDataDict, "three_ds_method_data", "");
        let threeDsIframe = document.querySelector("#threeDsAuthFrame");
        let elem = document.querySelector("#threeDsDiv");
        if (!(elem == null) && threeDsMethodUrl !== "") {
          let form = Utils$OrcaPaymentPage.makeForm(elem, threeDsMethodUrl, "threeDsHiddenPostMethod");
          let input = document.createElement("input");
          input.name = encodeURIComponent(methodKey);
          input.value = encodeURIComponent(threeDsMethodData);
          form.target = "threeDsAuthFrame";
          form.appendChild(input);
          form.submit();
        }
        Core__Option.forEach(timeoutRef.current, prim => {
          clearTimeout(prim);
        });
        timeoutRef.current = Primitive_option.some(setTimeout(() => {
          handleCompleteAuthorizeCall("N", clientSecret, publishableKey, headers, returnUrl, sdkAuthorization);
        }, 10000));
        if (!(threeDsIframe == null)) {
          threeDsIframe.addEventListener("load", param => {
            Core__Option.forEach(timeoutRef.current, prim => {
              clearTimeout(prim);
            });
            if (!isCompleteAuthorizeCalledRef.current) {
              handleCompleteAuthorizeCall("Y", clientSecret, publishableKey, headers, returnUrl, sdkAuthorization);
              return;
            }
          });
          return;
        } else {
          return;
        }
      } catch (exn) {
        return Utils$OrcaPaymentPage.postFailedSubmitResponse("complete_authorize_failed", "Something went wrong.");
      }
    };
    window.addEventListener("message", handle);
    return () => {
      window.removeEventListener("message", handle);
      Core__Option.forEach(timeoutRef.current, prim => {
        clearTimeout(prim);
      });
    };
  }, []);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("iframe", {
      id: "threeDsAuthFrame",
      title: "3D Secure Authentication Frame",
      name: "threeDsAuthFrame"
    }),
    className: "max-w-1 max-h-1 opacity-0 fixed left-[-9999px]",
    id: "threeDsDiv"
  });
}

let make = Redsys3ds;

export {
  make,
}
/* react Not a pure module */
